var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 471,
    viewBox: "0 0 750 471",
    width: 750,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0e4595",
    height: 471,
    rx: 40,
    width: 750
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m278.1975 334.2275 33.361-195.762h53.359l-33.384 195.762z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m524.3075 142.6875c-10.572-3.966-27.136-8.222-47.823-8.222-52.724 0-89.864 26.551-90.18 64.604-.297 28.129 26.514 43.821 46.754 53.185 20.769 9.595 27.752 15.715 27.653 24.283-.132 13.122-16.586 19.117-31.923 19.117-21.357 0-32.703-2.967-50.226-10.276l-6.876-3.112-7.489 43.824c12.463 5.464 35.509 10.199 59.438 10.444 56.089 0 92.501-26.247 92.915-66.882.201-22.269-14.015-39.217-44.799-53.188-18.651-9.056-30.073-15.099-29.952-24.269 0-8.137 9.668-16.838 30.557-16.838 17.449-.271 30.088 3.534 39.936 7.5l4.782 2.259z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m661.6145 138.4655h-41.231c-12.773 0-22.331 3.486-27.941 16.234l-79.245 179.403h56.031s9.162-24.122 11.234-29.418c6.123 0 60.554.084 68.336.084 1.596 6.853 6.492 29.334 6.492 29.334h49.512zm-65.417 126.407c4.413-11.279 21.259-54.723 21.259-54.723-.315.521 4.38-11.334 7.075-18.684l3.607 16.878s10.217 46.729 12.352 56.528h-44.293z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.878906 138.46484-.68164 4.07422c21.090997 5.10552 39.929199 12.49351 56.421874 21.68555l47.3457 169.69141 56.45508-.06641 84.00391-195.38477h-56.52149l-52.24023 133.4961-5.56641-27.12891c-.25746-.82795-.53628-1.65899-.82226-2.49023l-18.16602-87.34961c-3.23-12.396-12.5985-16.09535-24.1875-16.52735z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.e07d537765f5c097f7c0f3ab592d3d4c.svg";
export { ForwardRef as ReactComponent };